import { CustomExportFileModel } from "./customExportFile.model";

export class ListGoodsFilterViewModel {
    typeId: any;
    createByHubId: any;
    fromHubId: any;
    toHubId: any;
    fromHubIds: any[] = [];
    toHubIds: any[] = [];
    userId: any;
    statusId: any;
    transportTypeId: any;
    tplId: any;
    dateFrom: any;
    dateTo: any;
    //
    truckOwnerShipId: number;
    compartmentId: number;
    driverId: number;
    empId: number;
    truckId: number;
    pageNumber: number;
    PageSize: number;
    fromDate: any;
    toDate: any;
    pageSize: number;
    orderDateFrom: any
    orderDateTo: any;
    listGoodsTypeId: number;
    customExportFile: CustomExportFileModel = new CustomExportFileModel();
}
